'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconMarkdown, iconMarkdownTag } from '@ni/nimble-components/dist/esm/icons/markdown';
import { wrap } from '../../utilities/react-wrapper';

export type { IconMarkdown };
export { iconMarkdownTag };
export const NimbleIconMarkdown = wrap(IconMarkdown);